import "../../assets/css/clientAlerts/clientAlerts.css"

import { Tab, Tabs } from "react-bootstrap"

import { useState } from "react"
import { useAuth } from "../../context/auth-user"
import ActionNeededList from "./actionNeededTab/actionNeededList"
import HoldPaymentList from "./holdPaymentList"
import ContractList from "./contractList"

export default function ClientAlerts() {
    //VARIABLE TO MANAGE WHOS LOG IN
    const { user } = useAuth()
    const darkLightMode = user?.selectedProfile?.darkLightMode

    const [key, setKey] = useState(0)
    
    return (
        <section className={`alerts ${darkLightMode ? "darkMode" : null}`}>
            <div className="titleAndSearch">
                <h3 className="title">Alerts</h3>
            </div>
            
            <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => setKey(+k)}>

                <Tab eventKey={0} title="1 Action needed">
                    {key === 0 && <ActionNeededList />}
                </Tab>

                <Tab eventKey={1} title="2 Hold payment">
                    {key === 1 && <HoldPaymentList />}
                </Tab>

                <Tab eventKey={2} title="3 Contracts">
                    {key === 2 && <ContractList />}
                </Tab>
            </Tabs>
        </section>
    )
}
